module.exports = __webpack_public_path__ + "images/emoji/hotel.0992d020c2862136a3ba.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hotel.png
// module id = 5Ymy
// module chunks = 13